var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.ready && _vm.contracts
      ? _c(
          "div",
          { staticClass: "PrivateContractsForVehicleWidget__Component" },
          [
            _vm._l(_vm.contracts, function(item) {
              return _c(
                "div",
                {
                  key: item.Id,
                  staticClass:
                    "PrivateContractsForVehicleWidget__Component__Item"
                },
                [
                  _c("label", [
                    _vm._v(" שוכר: "),
                    _c(
                      "a",
                      { attrs: { href: "/clients/" + item.Profile.Id } },
                      [_c("span", [_vm._v(_vm._s(item.Profile.Name))])]
                    )
                  ]),
                  _c("label", [
                    _vm._v(" ח.פ: "),
                    _c("span", [_vm._v(_vm._s(item.Profile.IdNumber))])
                  ]),
                  item.ContractOwner
                    ? _c("label", [
                        _vm._v(" חברת ליסינג: "),
                        _c(
                          "a",
                          {
                            attrs: { href: "/clients/" + item.ContractOwner.Id }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(item.ContractOwner.Name))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "label",
                    [
                      _vm._v(" מתאריך: "),
                      _c("FieldDateHourInline", {
                        attrs: { value: item.StartDate }
                      })
                    ],
                    1
                  ),
                  _c(
                    "label",
                    [
                      _vm._v(" עד תאריך: "),
                      _c("FieldDateHourInline", {
                        attrs: { value: item.EndDate }
                      })
                    ],
                    1
                  ),
                  _c("label", [
                    _vm._v(" הצהרת חוכר: "),
                    _c("span", [
                      _vm._v(_vm._s(item.HasTransferHtml ? "כן" : "לא"))
                    ])
                  ]),
                  _c("label", [
                    _vm._v(" קיים טופס איסוף השכרה: "),
                    _c("span", [
                      _vm._v(_vm._s(item.HasRentalPickUpFormHtml ? "כן" : "לא"))
                    ])
                  ]),
                  _c("label", [
                    _vm._v(" קיים טופס החזרת השכרה: "),
                    _c("span", [
                      _vm._v(_vm._s(item.HasRentalReturnFormHtml ? "כן" : "לא"))
                    ])
                  ]),
                  _c("label", [
                    _vm._v(" קיים רישיון נהיגה: "),
                    _c("span", [
                      _vm._v(_vm._s(item.HasDriversLicenseHtml ? "כן" : "לא"))
                    ])
                  ]),
                  _c(
                    "a",
                    {
                      staticClass: "removeItem",
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.remove(item)
                        }
                      }
                    },
                    [_vm._v("מחק")]
                  )
                ]
              )
            }),
            !_vm.contracts.length
              ? _c("div", [_vm._v("לא קיים חוזה פרטי")])
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }